var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircleGreyIcon = function SvgCircleGreyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.33 18.333a8.333 8.333 0 1 0 .001-16.666 8.333 8.333 0 0 0 0 16.666Z",
    fill: "#DEE3F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.331 7.5-5.5 5-2.5-2.273",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCircleGreyIcon;